import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import React, { FunctionComponent } from "react";

// Red text button toggling a truncated category list between its collapsed
// and fully expanded states. Hidden when nothing is truncated.
export const ExpandTypesButton: FunctionComponent<{
  // number of entries hidden while the list is collapsed
  hiddenCount: number;
  isExpanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
}> = ({ hiddenCount, isExpanded, setExpanded }) => {
  const { t } = useTranslation();

  if (hiddenCount <= 0) {
    return;
  }
  return (
    <Button
      color="error"
      size="small"
      className="self-start p-0 min-w-0 normal-case"
      endIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      onClick={() => setExpanded(!isExpanded)}
    >
      {isExpanded
        ? t("views.metrics.showLess")
        : t("views.metrics.moreTypes", { count: hiddenCount })}
    </Button>
  );
};
